//#region src/surfaces/surface-manifest.ts
/** The two surface kinds (D5). `kind`, never `class` (D16). */
const SURFACE_KINDS = Object.freeze(["routed", "embedded"]);
/**
* A surface name: a lowercase base, then `.v` and its major, `invoice-list.v1`. A schema is
* immutable under its name, so a breaking change is a new name. Each quantifier runs over a class
* that excludes the next literal, so a match is linear in the input; callers check
* {@link SURFACE_NAME_MAX_LENGTH} first.
*/
const SURFACE_NAME_PATTERN = "^[a-z][a-z0-9-]*\\.v[1-9][0-9]{0,3}$";
/** The longest surface name, checked before {@link SURFACE_NAME_PATTERN}. Declared here for the JSON Schema and the wire twin; WS-1's parser imports it (R-20 Q1, escalated). */
const SURFACE_NAME_MAX_LENGTH = 64;
/**
* A `sharedDependencies` value: a package name, an `@`, and one major with no range,
* `react@19` or `@zion/sdk-surfaces@1`. `react@^19`, `react@19.1` and `react` do not match.
*/
const SHARED_MODULE_SPECIFIER_PATTERN = "^(@[a-z0-9][a-z0-9._-]*/)?[a-z0-9][a-z0-9._-]*@(0|[1-9][0-9]{0,3})$";
/** The longest `sharedDependencies` value, checked before {@link SHARED_MODULE_SPECIFIER_PATTERN} (R-20 Q1, escalated). */
const SHARED_MODULE_SPECIFIER_MAX_LENGTH = 128;
/**
* An output name: lowercase words joined by hyphens, `navigate`, `session-established`. The
* grammar admits no `:`, so no output can spell the runtime's reserved `surface:` event prefix
* (R-3).
*/
const SURFACE_OUTPUT_NAME_PATTERN = "^[a-z][a-z0-9-]*$";
/** The longest output name. */
const SURFACE_OUTPUT_NAME_MAX_LENGTH = 64;
/**
* The app slug a `uses[]` row names: the `appId` grammar of `app-manifest.schema.json`, which a
* test holds equal.
*/
const SURFACE_USE_APP_PATTERN = "^[a-z][a-z0-9-]*[a-z0-9]$";
/** The longest app slug a `uses[]` row names, equal to `app-manifest.schema.json`'s `appId` cap. */
const SURFACE_USE_APP_MAX_LENGTH = 30;
/** The longest `uiPackage`, npm's package-name cap. */
const SURFACE_UI_PACKAGE_MAX_LENGTH = 214;
/** The most surfaces one `app.json` declares. */
const MAX_SURFACES_PER_APP = 64;
/** The most outputs one surface or one `uses[]` row declares. */
const MAX_SURFACE_OUTPUTS = 32;
/** The most `uses[]` rows one surface declares. */
const MAX_SURFACE_USES = 32;
/** The most `sharedDependencies` values one surface declares. */
const MAX_SHARED_DEPENDENCIES = 16;
//#endregion
export { MAX_SHARED_DEPENDENCIES, MAX_SURFACES_PER_APP, MAX_SURFACE_OUTPUTS, MAX_SURFACE_USES, SHARED_MODULE_SPECIFIER_MAX_LENGTH, SHARED_MODULE_SPECIFIER_PATTERN, SURFACE_KINDS, SURFACE_NAME_MAX_LENGTH, SURFACE_NAME_PATTERN, SURFACE_OUTPUT_NAME_MAX_LENGTH, SURFACE_OUTPUT_NAME_PATTERN, SURFACE_UI_PACKAGE_MAX_LENGTH, SURFACE_USE_APP_MAX_LENGTH, SURFACE_USE_APP_PATTERN };

//# sourceMappingURL=surface-manifest.js.map